import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { sections } from '../data/profile';
interface SectionPagerProps {
  current: string;
}
export function SectionPager({
  current
}: SectionPagerProps) {
  const index = sections.findIndex(s => s.path === current);
  const prev = index > 0 ? sections[index - 1] : null;
  const next = index < sections.length - 1 ? sections[index + 1] : null;
  return <nav aria-label="Section navigation" className="border-t border-navy/10 bg-paper" data-id="element-104" data-mp="1zfn54mohi94">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-px px-6 sm:grid-cols-2 lg:px-10" data-id="element-105" data-mp="3t5z6572o4eii">
        <div className="border-b border-navy/10 py-8 sm:border-b-0 sm:border-r sm:border-navy/10 sm:pr-8" data-id="element-106" data-mp="avn7ii26b4y4">
          {prev && <Link to={prev.path} className="group inline-flex items-start gap-4" data-id="element-107" data-mp="1mcn6txmxuk1n">
              <ArrowLeftIcon className="mt-2 h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out group-hover:-translate-x-1" aria-hidden="true" data-id="element-108" data-mp="1hebzbtk48lml" />
              <span data-id="element-109" data-mp="mqx0z5s6p1je">
                <span className="block text-[11px] uppercase tracking-overline text-steel" data-id="element-110" data-mp="mqexpp73tn1z">
                  Previous · {prev.number}
                </span>
                <span className="mt-1.5 block font-display text-xl font-light text-navy" data-id="element-111" data-mp="wpm7k2emqzkc">
                  {prev.title}
                </span>
              </span>
            </Link>}
        </div>
        <div className="py-8 sm:pl-8 sm:text-right" data-id="element-112" data-mp="40p2x23cd1a2">
          {next && <Link to={next.path} className="group inline-flex items-start gap-4 sm:flex-row-reverse" data-id="element-113" data-mp="3yvr78dvfqv7">
              <ArrowRightIcon className="mt-2 h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-114" data-mp="8y8gs0w4nc1h" />
              <span data-id="element-115" data-mp="3hfv5w0kmtht6">
                <span className="block text-[11px] uppercase tracking-overline text-steel" data-id="element-116" data-mp="3hfbk28rv299v">
                  Next · {next.number}
                </span>
                <span className="mt-1.5 block font-display text-xl font-light text-navy" data-id="element-117" data-mp="39d2mcgd9tkfw">
                  {next.title}
                </span>
              </span>
            </Link>}
        </div>
      </div>
    </nav>;
}